<template>
  <div
    class="flex-col w-full h-full text-sm font-medium text-center center-content gap-y-2"
  >
    <ClipLoaderVue size="35" color="green-500" />
    <p>Loading...</p>
  </div>
</template>

<script>
export default {
    name:"SecondLoader"
};
</script>

<style>
</style>